import { Link } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看全部" }: Props) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1.5 rounded-full bg-accent-500" />
        <div>
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs text-foreground-400">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}